import * as React from 'react';
import { RootContext } from '../RootContainer';
import { SocialsWrapper } from '../../components/socials';
import { expand } from '../../actions/social';
import { useDeprecatedSocialCallback } from './hooks/useDeprecatedSocialCallback';
import { expandedSelector, socialErrorSelector } from './selectors';
import { INITIALLY_EXPANDED_SOCIALS_LIMIT, SOCIAL_NETWORKS, VISIBLE_SOCIALS_COUNT } from './constants';
export function SocialsContainer(_ref) {
  var useDispatch = _ref.useDispatch,
    useSelector = _ref.useSelector;
  var _React$useContext = React.useContext(RootContext),
    disabledSocials = _React$useContext.disabledSocials,
    frameless = _React$useContext.frameless;
  var dispatch = useDispatch();
  var expanded = useSelector(expandedSelector);
  var error = useSelector(socialErrorSelector);
  var handleSocialClick = useDeprecatedSocialCallback(useDispatch);
  var _React$useMemo = React.useMemo(function () {
      var socialListFull = SOCIAL_NETWORKS.filter(function (social) {
        return !disabledSocials.includes(social);
      });
      var socialListShort = socialListFull.slice(0, VISIBLE_SOCIALS_COUNT);
      return {
        socialListFull: socialListFull,
        socialListShort: socialListShort
      };
    }, [disabledSocials]),
    socialListFull = _React$useMemo.socialListFull,
    socialListShort = _React$useMemo.socialListShort;

  // Если сейчас доступно INITIALLY_EXPANDED_SOCIALS_LIMIT соц сетей,
  // то нет смысла скрывать их под кнопкой "раскрыть", показываем все сразу
  var isExpanded = socialListFull.length <= INITIALLY_EXPANDED_SOCIALS_LIMIT || expanded;
  var currentSocialList = isExpanded ? socialListFull : socialListShort;
  var handleExpand = React.useCallback(function () {
    if (!expanded) {
      dispatch(expand());
    }
  }, [dispatch, expanded]);
  if (socialListFull.length === 0) {
    return null;
  }
  return /*#__PURE__*/React.createElement(SocialsWrapper, {
    list: currentSocialList,
    isExpanded: isExpanded,
    expand: handleExpand,
    error: error,
    frameless: frameless,
    onClick: handleSocialClick
  });
}